var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"w-full"},[(!_vm.maskedAttributes.includes('name'))?[_vm._t("default")]:[_vm._v(" Anonymous ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }